import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import Noimg from "../images/no_img.jpg";
import ProductCommon from "../components/ProductLike&Wish";
import "react-loading-skeleton/dist/skeleton.css";
import no_data from "images/no_data.png";
import SkeletonLoader from "components/SkeletonLoader";
import { getProduct, orderStatus } from "api/ProductApi";
import { currentRegister } from "utility/Constant";
import { getBranchId } from "utility/HeaderConfig";

export default ({ configImages }) => {
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [size, setSize] = useState(12);
  const [orderStatusSale, setOrderStatusSale] = useState("");
  const [orderStatusTransfer, setOrderStatusTransfer] = useState("");
  const [orderStatusSold, setOrderStatusSold] = useState("");
  const [hoveredIdx, setHoveredIdx] = useState(null);

  useEffect(() => {
    Promise.all([
      getOrderStatusSale(),
      getOrderStatusTransfer(),
      getOrderStatusSold(),
    ])
      .then((result) => {
        getMostLiked(result[0], result[1], result[2]);
      })
      .catch((err) => console.error(err));
    //eslint-disable-next-line
  }, []);

  const history = useNavigate();

  const getOrderStatusSale = () =>
    orderStatus({ orderStatusName: "sale" })
      .then((data) => { setOrderStatusSale(data.response[0].id); return data.response[0].id; })
      .catch((err) => console.error(err));

  const getOrderStatusTransfer = () =>
    orderStatus({ orderStatusName: "Transferred" })
      .then((data) => { setOrderStatusTransfer(data.response[0].id); return data.response[0].id; })
      .catch((err) => console.error(err));

  const getOrderStatusSold = () =>
    orderStatus({ orderStatusName: "Sold" })
      .then((data) => { setOrderStatusSold(data.response[0].id); return data.response[0].id; })
      .catch((err) => console.error(err));

  const getMostLiked = (orderSaleStatus, orderTransferStatus, orderSoldStatus) => {
    setLoading(true);
    setSize(size + 8);
    if (orderSaleStatus && orderTransferStatus && orderSoldStatus) {
      getProduct(size, {
        branch: getBranchId(),
        productLabel: "Most Liked Products",
        removeNTP: "NTP-",
        removeHp: "HP-",
        beforeCreatedAt: currentRegister(),
        demoStatus: "Demo_Completed,Demo_Cancelled,Available_For_Demo",
        statusId: `${orderSaleStatus}, ${orderTransferStatus}, ${orderSoldStatus}`,
      })
        .then((data) => { setCategoryList(data.response.content); setLoading(false); })
        .catch((err) => { console.error(err); });
    }
  };

  const imgSrc = (item) =>
    item.images === "@#@" || !item.images ? Noimg : item.images.split("@#@")[0];

  return (
    <div style={{ background: "#faf8fc", minHeight: "80vh" }}>
      {/* Breadcrumb */}
      <div style={{ background: "#fff", borderBottom: "1px solid #f0ebf8", padding: "14px 0" }}>
        <div className="container">
          <nav style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 11, color: "#b4a78a" }}>
            <Link to="/" style={{ color: "#b4a78a", textDecoration: "none", fontWeight: 500 }}>Home</Link>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
            <span style={{ color: "#6b5330", fontWeight: 600 }}>Most Liked Products</span>
          </nav>
        </div>
      </div>

      <div className="container" style={{ padding: "40px 15px" }}>
        {/* Page header */}
        <div style={{ marginBottom: 36 }}>
          <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".18em", textTransform: "uppercase", color: "#eab333", margin: "0 0 6px" }}>
            Trending
          </p>
          <h1 style={{
            fontFamily: "Cormorant Garamond, Georgia, serif",
            fontSize: "clamp(28px,4vw,42px)", fontWeight: 600,
            color: "#2e240d", margin: 0,
          }}>
            Most Liked Products
          </h1>
        </div>

        {loading && <SkeletonLoader />}

        {!loading && categoryList.length === 0 && (
          <div style={{ textAlign: "center", padding: "60px 0" }}>
            <img src={no_data} alt="no-data" style={{ maxWidth: 220, margin: "0 auto" }} />
          </div>
        )}

        {/* Product grid */}
        <div className="ml-grid">
          {categoryList.map((item, index) => (
            <motion.div
              key={index}
              className="ml-card"
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.26, delay: Math.min(index * 0.03, 0.4) }}
              onMouseEnter={() => setHoveredIdx(index)}
              onMouseLeave={() => setHoveredIdx(null)}
              onClick={() => history(`/ProductDetails/${item.id}`, { state: { categoryItem: item } })}
              style={{
                background: "#fff",
                borderRadius: 16,
                overflow: "hidden",
                cursor: "pointer",
                boxShadow: hoveredIdx === index
                  ? "0 14px 36px rgba(79,50,103,.15)"
                  : "0 2px 10px rgba(0,0,0,.05)",
                transform: hoveredIdx === index ? "translateY(-4px)" : "none",
                transition: "box-shadow .26s, transform .26s",
                border: "1px solid #f0ebf8",
                position: "relative",
              }}
            >
              {/* Like/Wish */}
              <div style={{ position: "absolute", top: 10, right: 10, zIndex: 2 }} onClick={(e) => e.stopPropagation()}>
                <ProductCommon categoryItem={item} />
              </div>

              {/* Status badge */}
              <span style={{
                position: "absolute", top: 10, left: 10, zIndex: 2,
                background: item.status === "Sale" ? "#e6f9f0" : "#fef2f2",
                color: item.status === "Sale" ? "#166534" : "#991b1b",
                border: `1px solid ${item.status === "Sale" ? "#86efad" : "#fca5a5"}`,
                fontSize: 10, fontWeight: 700, padding: "3px 9px",
                borderRadius: 999,
              }}>
                {item.status === "Sale" ? "Available" : "Sold"}
              </span>

              {/* Image */}
              <div style={{ overflow: "hidden", background: "#f9f5fd", aspectRatio: "1" }}>
                <img
                  src={imgSrc(item)}
                  alt={item.title}
                  style={{
                    width: "100%", height: "100%", objectFit: "cover",
                    transform: hoveredIdx === index ? "scale(1.06)" : "scale(1)",
                    transition: "transform .5s cubic-bezier(.16,1,.3,1)",
                  }}
                />
              </div>

              {/* Info */}
              <div style={{ padding: "12px 14px 14px" }}>
                <p style={{ fontSize: 10.5, fontWeight: 600, letterSpacing: ".08em", textTransform: "uppercase", color: "#aaa", margin: "0 0 3px" }}>
                  {item.metalType}
                </p>
                <p style={{
                  fontSize: 13, fontWeight: 500, color: "#ad8b3a",
                  margin: "0 0 10px",
                  whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                  textTransform: "capitalize",
                }} title={item.title}>
                  {item.category}
                </p>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontSize: 16, fontWeight: 700, color: "#6b5330", fontFamily: "Cormorant Garamond, Georgia, serif" }}>
                    ₹{Math.trunc(item.total).toLocaleString("en-IN")}
                  </span>
                  {item.goldPurity && item.goldPurity !== "-" && (
                    <span style={{
                      fontSize: 10, fontWeight: 600,
                      background: "#f5f0fa", color: "#ad8b3a",
                      padding: "2px 8px", borderRadius: 999,
                      border: "1px solid #f8efd9",
                    }}>
                      {item.goldPurity}
                    </span>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* View more */}
        <div style={{ display: "flex", justifyContent: "center", paddingTop: 48 }}>
          <button
            style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              padding: "12px 36px",
              background: loading ? "#f8efd9" : "#6b5330",
              color: "#fff",
              fontSize: 13, fontWeight: 700, letterSpacing: ".08em",
              border: "none", borderRadius: 999, cursor: loading ? "default" : "pointer",
              transition: "background .14s",
              textTransform: "uppercase",
            }}
            onClick={() => getMostLiked(orderStatusSale, orderStatusTransfer, orderStatusSold)}
            disabled={loading}
          >
            {loading ? "Loading..." : "Load More"}
          </button>
        </div>
      </div>

      <style>{`
        .ml-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 18px;
        }
        @media (max-width: 1100px) { .ml-grid { grid-template-columns: repeat(3,1fr) !important; } }
        @media (max-width: 720px)  { .ml-grid { grid-template-columns: repeat(2,1fr) !important; gap: 12px !important; } }
        @media (max-width: 420px)  { .ml-grid { grid-template-columns: repeat(1,1fr) !important; } }
      `}</style>
    </div>
  );
};